import * as React from 'react';
import { useParams } from 'react-router';

import { FormReviewBaseTypeParams, routes } from 'config/routes';
import { FormReviewFlatTableStoreProvider } from 'stores/local/FormReviewStore';

import { useFormReviewPage } from '../context';

import { FormReviewPageFlatTableContent } from './Content';

export const FormReviewFlatTable: React.FC = () => {
  const { setRoute } = useFormReviewPage();

  const { id } = useParams<FormReviewBaseTypeParams>();

  React.useEffect(() => {
    setRoute(routes.form.formReview.createPath(Number(id)));
  }, [id, setRoute]);

  return (
    <FormReviewFlatTableStoreProvider>
      <FormReviewPageFlatTableContent />
    </FormReviewFlatTableStoreProvider>
  );
};

export default FormReviewFlatTable;
